export type Langs = {
	pt: string;
	en: string;
	es: string;
};

export type SurveyQuestionOption = {
	id: string;
	text: Langs;
};

export type Question = {
	id: string;
	title: Langs;
	description?: Langs;
	isRequired: boolean;
	type: 'text' | 'multi';
	maxSelections?: number;
	options?: SurveyQuestionOption[];
};

export type DisplayConfig = {
	displayFormat: string;
	planType: string[];
	subscriptionState: string[];
	userRole: string[];
	applicationPage?: string[];
	redisplayInDays?: number;
};

export type Survey = {
	id: string;
	application: string;
	title: Langs;
	description: Langs;
	isActive: boolean;
	createdAt: string;
	questions: Question[];
	displayConfig: DisplayConfig;
	isAnswered?: boolean;
	canDiscard?: boolean;
};

export enum EventType {
	ignored = 'ignored',
	discarded = 'discarded',
}

type TextAnswer = {
	questionId: string;
	questionText: string;
	type: 'text';
	answerText: string;
};

export type MultiAnswer = {
	questionId: string;
	questionText: string;
	type: 'multi';
	answerMulti: {
		optionSelectedId: string | undefined;
		optionSelectedText: string;
	}[];
};

export type Answer = TextAnswer | MultiAnswer;

export type SurveyResponsePayload = {
	surveyId?: string;
	language: string;
	answers: Answer[] | null;
	user?: UserFilter;
};

export type UserFilter = {
	internalId?: string;
	role?: string;
	email?: string;
	clientId?: string;
	application?: string;
	domain?: string;
};
